import type { Load } from '../types';
import { money, shortDate, weight } from '../lib/format';

interface Props {
  loads: Load[];
  selectedId: string | null;
  onSelect: (loadId: string) => void;
}

export function LoadRail({ loads, selectedId, onSelect }: Props) {
  return (
    <nav className="rail" aria-label="Open loads">
      <div className="rail-head">
        <h2>Open loads</h2>
        <span className="sub-note">{loads.length}</span>
      </div>

      {loads.map((load) => {
        const tight = load.daysToDeadline <= 1;
        return (
          <button
            key={load.loadId}
            type="button"
            className={`load-item${selectedId === load.loadId ? ' active' : ''}`}
            onClick={() => onSelect(load.loadId)}
            aria-current={selectedId === load.loadId ? 'true' : undefined}
          >
            <div className="row1">
              <span className="id">{load.loadId}</span>
              {load.selection ? (
                <span className={`chip ${load.selection.booked ? 'good' : 'accent'}`}>
                  <span className="dot" aria-hidden="true" />
                  {load.selection.booked ? 'Booked' : 'Selected'}
                </span>
              ) : tight ? (
                <span className="chip critical">
                  <span className="dot" aria-hidden="true" />
                  Tight
                </span>
              ) : null}
            </div>

            <div className="cust">{load.custName}</div>

            <div className="meta">
              <span>
                {load.warehouse.state} → {load.shipTo.state} {load.shipTo.zip}
              </span>
              <span>{weight(load.totalWeight)}</span>
            </div>
            <div className="meta">
              <span>Need by {shortDate(load.requiredByDate)}</span>
              {load.selection?.rate != null && <span>{money(load.selection.rate)}</span>}
            </div>
          </button>
        );
      })}
    </nav>
  );
}
